module.exports = function() {
  return new Worker(__webpack_public_path__ + "4fc433c471efb37eca2b.worker.js");
};